import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useLabelTranslations = () => {
  const { formatMessage } = useIntl();

  const labelTranslations = useMemo(() => {
    return {
      labelName: formatMessage(messages.labelName),
      labelModalityName: formatMessage(messages.labelModalityName),
      labelOfferings: formatMessage(messages.labelOfferings),
      labelPrice: formatMessage(messages.labelPrice),
      labelDepositAmount: formatMessage(messages.labelDepositAmount),
      labelVisibility: formatMessage(messages.labelVisibility),
      labelDescription: formatMessage(messages.labelDescription),
      labelMarketingText: formatMessage(messages.labelMarketingText),
      marketingPlaceholder: formatMessage(messages.marketingPlaceholder),
      labelDuration: formatMessage(messages.labelDuration),
      labelPublicPackagePrivateOfferings: formatMessage(
        messages.labelPublicPackagePrivateOfferings,
      ),
    };
  }, [formatMessage]);

  return labelTranslations;
};

export default useLabelTranslations;
